module.exports = __webpack_public_path__ + "static/8biticon-7ba989f0b6b509d697f9dbe2bb1eb7ce.jpg";